import { useSocketStatusStore } from "@/runtime/socket/socketStatusStore";

/**
 * Hook that returns true when any background sync operation is active.
 * 
 * Tracks:
 * - Live assistance connecting state
 * - Pending turn acknowledgments
 * 
 * Note: Socket.IO reconnection and session resume are handled internally by
 * the runtime and don't need explicit progress indication. The reconnection
 * process is fast enough that it doesn't require user-facing feedback, and
 * session resume is covered by the pending turn state during message replay.
 * 
 * @returns true if any background operation is active
 */
export function useBackgroundSync(): boolean {
  // Track live assistance connecting state
  const isLiveConnecting = useSocketStatusStore((state) => state.liveAssistance.isConnecting);

  // Track pending turn (waiting for acknowledgment)
  const hasPendingTurn = useSocketStatusStore((state) => 
    state.activeTurn !== null && !state.activeTurn.acknowledged
  );

  return isLiveConnecting || hasPendingTurn;
}
